const CustomerPlayerSecurity = ({ support, licensing, supportedLanguages, name }) => {
  return (
    <section className="mt-12 max-w-[1440px] mx-auto px-5 sm:px-8 md:px-12 lg:px-16 xl:px-20 pb-16 transition-colors duration-300">
      {/* Section Heading */}
      <div className="mb-6 text-left">
        <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
          Customer Support & Player Security
        </h2>
        <hr className="border-t-[1px] border-gray-400 dark:border-gray-600 mb-3" />
        <p className="text-gray-600 dark:text-gray-300">
          Understand your options as a player when getting in touch with help
          from {name} and what security and licensing they provide.
        </p>
      </div>

      {/* 2-column layout */}
      <div className="flex flex-col lg:flex-row gap-8 items-start">
        {/* ===== Support Options (60%) ===== */}
        <div className="bg-white dark:bg-[#1e2430] border border-gray-300 dark:border-gray-600 rounded-2xl p-8 w-full lg:w-[60%] transition-colors duration-300">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-6 text-left">
            Support Options
          </h3>

          {/* Support Cards */}
          <div className="space-y-4">
            {support.map((item, i) => (
              <div
                key={i}
                className="flex justify-between items-center border border-gray-300 dark:border-gray-600 rounded-2xl px-8 py-5 bg-white dark:bg-[#1e2430] transition-all duration-300 hover:shadow-md"
              >
                <div className="flex flex-col justify-center items-start leading-tight">
                  <p className="text-[16px] font-semibold text-gray-900 dark:text-gray-200">
                    {item?.supportOption?.name}
                  </p>
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    {item.description}
                  </p>
                </div>
                <span className="text-[15px] font-medium text-gray-700 dark:text-gray-400">
                  {item.isLimited ? "Limited" : "Available"}
                </span>
              </div>
            ))}
          </div>

          {/* Support Languages */}
          <div className="flex flex-col items-start mt-5">
            <p className="text-[15px] font-semibold text-gray-900 dark:text-gray-200 mb-1">
              Support Languages:
            </p>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              {supportedLanguages}
            </p>
          </div>
        </div>

        {/* ===== Security & Licensing (40%) ===== */}
        <div className="bg-white dark:bg-[#1e2430] border border-gray-300 dark:border-gray-600 rounded-2xl p-8 h-fit w-full lg:w-[40%] self-start transition-colors duration-300">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-6 text-left">
            Security & Licensing
          </h3>

          {/* Tags */}
          <div className="flex flex-wrap gap-2 mb-6 text-[13px] font-semibold text-gray-900 dark:text-gray-200">
            {licensing.map((tag, j) => (
              <span
                key={j}
                className="px-3 py-1 rounded-full border border-gray-300 dark:border-gray-600 bg-white dark:bg-[#1e2430] transition-colors duration-300"
              >
                {tag.label}
              </span>
            ))}
          </div>

          {/* 
          Licenses section commented out
          <div className="text-left mt-2">
            <p className="font-semibold text-gray-900 dark:text-gray-100 mb-3 text-[17px]">
              Licenses
            </p>
            <div className="flex items-center gap-4">
              <img
                src={defaultLogo}
                alt="MGA"
                className="h-10 w-16 object-contain rounded border border-gray-300 dark:border-gray-600 p-1 bg-white dark:bg-[#1b1f2a]"
              />
              <img
                src={defaultLogo}
                alt="Gambling Commission"
                className="h-10 w-16 object-contain rounded border border-gray-300 dark:border-gray-600 p-1 bg-white dark:bg-[#1b1f2a]"
              />
            </div>
          </div>
          */}
        </div>
      </div>
    </section>
  );
};

export default CustomerPlayerSecurity;
